import { render } from "./Navigation.vue?vue&type=template&id=4e9ea1b5"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=4e9ea1b5&lang=scss"
script.render = render

export default script